<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Remessas</b>
            </h3>
            <button
              class="btn btn-primary pull-right"
              @click="gerarRemessa"
              v-if="hasPermission('administrador')"
            >
              <i class="fa fa-plus"></i> Gerar Remessa
            </button>
          </div>

          <div class="box-body">
            <div class="row" style="margin-top:15px">
              <div class="col-sm-12 table-responsive">
                <table
                  aria-describedby="example1_info"
                  role="grid"
                  id="example1"
                  class="table table-bordered table-striped"
                >
                  <thead>
                    <tr role="row">
                      <th style="width: 10%;">ID</th>
                      <th style="width: auto;">Qt. Entradas</th>
                      <th style="width: auto;">Entradas (R$)</th>
                      <th style="width: auto;">Qt. Baixas</th>
                      <th style="width: auto;">Baixas (R$)</th>
                      <th style="width: auto;">Arquivo</th>
                      <th style="width: 15%;">Gerado por</th>
                      <th style="width: 10%">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="even" role="row" v-for="item in dataTable.data" :key="item.id">
                      <td>{{ item.id }}</td>
                      <td>{{ item.quantidade_entrada }}</td>
                      <td>{{ item.total_valor_entrada | numberFormat(2,',','.') }}</td>
                      <td>{{ item.quantidade_baixa }}</td>
                      <td>{{ item.total_valor_baixa | numberFormat(2,',','.') }}</td>
                      <td>{{ item.arquivo }}</td>
                      <td>{{ item.usuario.name }} em {{ item.created_at | dataHoraFormatada }}</td>
                      <td>
                        <a
                          class="btn btn-warning btn-sm"
                          :href="`${$store.state.s3URI}/nova_garantia/remessas/${item.arquivo}`"
                          target="_blank"
                          download
                          title="Download"
                        >
                          <i style="font-size:12px" class="fa fa-fw fa-download"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="row">
                  <div
                    class="col-sm-5"
                  >Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.</div>

                  <div class="col-sm-7" style="text-align:right">
                    <laravue-pagination
                      :data="dataTable"
                      v-on:pagination-change-page="getDataTable"
                      :limit="5"
                    >
                      <span slot="prev-nav">&lt; Anterior</span>
                      <span slot="next-nav">Próximo &gt;</span>
                    </laravue-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http

export default {
  filters: {},
  data: () => ({
    filtros: {
      pesquisa: "",
      coluna: null,
      ordem: null
    },
    dataTable: {}
  }),
  mounted() {
    this.getDataTable();
  },
  methods: {
    filtrar: function(filtros) {
      this.filtros = { ...this.filtros, ...filtros };
      this.getDataTable();
    },

    getDataTable(page) {
      if (typeof page === "undefined") {
        page = 1;
      }

      this.filtros.page = page;
      this.$store.commit("TOGGLE_LOADING");

      let config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;
      console.log(this.filtros);
      axios
        .get(`${this.$store.state.serverURI}/api/boleto/getRemessas`, config)
        .then(response => {
          this.dataTable = response.data;
          this.$store.commit("TOGGLE_LOADING");
        })
        .catch(error => {
          this.$store.commit("throwException", error);
        });
    },
    gerarRemessa(id, nome) {
      this.$swal({
        title: `Confirma geração do arquivo de remessa?`,
        text: ``,
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
        cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          this.$swal({
            title: "Aguarde...",
            imageUrl: "/static/img/Rolling-green.gif",
            showConfirmButton: false,
            allowOutsideClick: false
          });

          axios
            .post(
              `${this.$store.state.serverURI}/api/boleto/gerarRemessa`,
              {},
              this.$store.getters.getHeaderAuth
            )
            .then(response => {
              this.getDataTable();
              this.$swal({
                type: response.data.type,
                title: response.data.title,
                text: response.data.msg,
                showConfirmButton: true
              });
            })
            .catch(error => {
              console.log(error);
            });
        }
      });
    }
  },
  watch: {
    page: function(val) {
      this.getDataTable();
    }
  },

  components: {}
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// index.vue?19433d46